import { useTranslation } from 'react-i18next';
import { BaseModal, BaseModalProps, TextCutter } from '@anytag/shared-atoms';

export interface DeleteTagModalProps extends BaseModalProps {
  tag?: string;
  loading?: boolean;
  onDelete?: () => void;
}

export const DeleteTagModal = ({
  tag,
  title,
  footer,
  loading,
  onClose,
  onDelete,
  ...restProps
}: DeleteTagModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      description={t('Dialog.DeleteComparableHashtagWarning')}
      title={
        <>
          <span>{title ?? t('Dialog.Delete Hashtag')}</span>
          {tag ? (
            <>
              &nbsp;
              <TextCutter text={tag} />
            </>
          ) : null}
        </>
      }
      footer={{
        ...footer,
        cancelButton: { title: t('Button.Cancel'), onClick: onClose, ...footer?.cancelButton },
        submitButton: { title: t('Button.Delete'), onClick: onDelete, loading, ...footer?.submitButton }
      }}
      {...restProps}
    />
  );
};
